module.exports = __webpack_public_path__ + "img/stc.f12e7b39.svg";